export default (function (_ref) {
  var request = _ref.request;
  return {
    /**
       * @description 订单列表
       * @description http://yapi.xiya.vip/project/11/interface/api/75
       */
    MARKET_ADMIN_DEVICE_ALL: function MARKET_ADMIN_DEVICE_ALL() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/api/market-admin-device/index',
        method: 'post',
        data: query
      });
    },

    /**
       * @description 新闻创建
       * @description http://yapi.xiya.vip/project/11/interface/api/80
       */
    MARKET_ADMIN_DEVICE_CREATE: function MARKET_ADMIN_DEVICE_CREATE(data) {
      return request({
        url: '/api/market-admin-device/create',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 字典详情
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    MARKET_ADMIN_DEVICE_DETAIL: function MARKET_ADMIN_DEVICE_DETAIL(id) {
      return request({
        url: '/api/market-admin-device/update',
        method: 'post',
        data: {
          id: id
        }
      });
    },

    /**
       * @description 字典编辑
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    MARKET_ADMIN_DEVICE_UPDATE: function MARKET_ADMIN_DEVICE_UPDATE(data) {
      return request({
        url: '/api/market-admin-device/update',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 新闻删除
       * @description http://yapi.xiya.vip/project/11/interface/api/90
       */
    MARKET_ADMIN_DEVICE_DELETE: function MARKET_ADMIN_DEVICE_DELETE(id) {
      return request({
        url: '/api/market-admin-device/delete',
        method: 'delete',
        data: {
          id: id
        }
      });
    },
    MARKET_ADMIN_DEVICE_SYNC: function MARKET_ADMIN_DEVICE_SYNC(data) {
      return request({
        url: '/api/market-admin-device/sync',
        method: 'post',
        data: data
      });
    }
  };
});